import { makeStyles, Theme } from '@material-ui/core/styles';

const styles = makeStyles(({ spacing, palette, typography }: Theme) => ({
  root: {
    textTransform: 'none',
    boxShadow: 'none',
  },

  label: { ...typography.h4, padding: `${spacing(1)}px 0` },
  inProgress: {
    backgroundColor: palette.common.white,
    color: `${palette.text.secondary}`,
    cursor: 'default',
    '&:hover, &:focus, &:disabled': {
      backgroundColor: palette.common.white,
    },
  },
}));

export default styles;
